import uuid from 'uuid/v4';
import { convertToEditorState } from '../../components/RichTextEditor';
import { parseJSON } from '../utils';

export default function newOutput(
{
  defaultAspectRatio,
  defaultDuration,
  outputCost,
  isMaster,
  video,
  editingMode,
  updatedIndex








} = {})
{
  return {
    outputId: uuid(),
    name: updatedIndex > 0 ? `Iteration ${updatedIndex}` : null,
    aspectRatio: defaultAspectRatio || 'WIDE',
    latestVersion: 1,
    status: { name: `${editingMode ? 'PENDING_MASTER' : 'DRAFT'}` },
    versions: [{
      appliedAddons: { DURATION: { value: defaultDuration || 'STANDARD' } },
      versionNumber: 1,
      versionId: uuid(),
      dueDate: null
    }],
    isMaster: Boolean(isMaster),
    isNew: true,
    outputCost,
    notes: convertToEditorState(parseJSON('')),
    videoId: '',
    readableId: '',
    video
  };
}